import { ConfigurableStoreProductType, DesignStoreProductType, IProductDetailController, IProductDetailState, IPropertyDetailScope, SkuStoreProductType } from "./product-detail";
import { ProductDetailObjectTree } from "./product-detail-object-tree";
import { PropertyModel } from "@modules/property-model/model/domain/PropertyModel";
import { IPartnerRestService } from "@modules/user/rest/partner/partner-rest-service";
import { SetupInitParams } from "../../store-product/store-product";
import { IProductRestService } from "@modules/product/rest/products-rest";
import { IWhitelabelProductIdResult, StoreProductTypeListResult, IStoreProductType, ICurrentProduct } from "./product-detail";
import { BuilderUrlRequestParameter } from "@modules/main/model/domain/builder/builder-url-request-parameter";

import { IStoreAndTypeResult } from "./stores-and-type/store-and-type";
import { IBuilderPathRest, IPathParams } from "@modules/main/rest/builder/builder-rest";
import { BuilderManager } from "@modules/main/builder/service/builder.manager";

export class ProductDetailAuthorized implements IProductDetailState {
    public static readonly $inject: string[] = ["partnerRestService", "$objectTree", "qpLoading", "$uibModal", "pageContext", "$window", "$q", 'builderRestService'];
    constructor(public $objectTree: ProductDetailObjectTree, public partnerRestService: IPartnerRestService, public qpLoading: qp.loading.IQpLoading, public $uibModal: angular.ui.bootstrap.IModalService, public $scope: IPropertyDetailScope, public pageContext: qpmn.main.IPageContext, private $window: angular.IWindowService, public productV2RestService: IProductRestService, public $q: angular.IQService, public builderRestService: IBuilderPathRest,) { };
    public isLogin: boolean = true;
    protected context: IProductDetailController;

    public setContext(context: IProductDetailController): void {
        this.context = context;
    }
    /**
     * @description 开发店铺列表模态框，选中预添加产品店铺(partner邮箱是否激活校验)
     * @param propertyModelId
     * @param storeId
     * */
    public selectedStore(propertyModelId: number | undefined, storeId: string | undefined): void {
        this.context.qpLoading.open();
        // 检查是否已激活邮箱
        this.partnerRestService.get().then(res => {
            if (!res.data.isVerifyEmail) {
                this.context.qpLoading.close();
                // Partner未激活提示处理
                window.qpAlertPrompt.info("Mailbox verification", "You need to verify your email address!", {
                    text: "Ok",
                    fn: () => {
                        this.$window.location.href = this.context.pageContext.rootPath + "dashboard/#!/account/e-shopper";
                    }
                }, {
                    text: "Cancel",
                    fn: () => {
                        return;
                    }
                }, {
                    reverseButtons: true,
                    // 是否显示取消按钮
                    showCancelButton: true,
                });
                return;
            }

            //创建可选店铺产品类型数据（允许添加的店铺产品类型SKU、CONFIGURABLE、DESIGN ）
            this.getStoreProductTypeList(this.context.currentProductId)
                .then(res => {
                    if (!res.success) {
                        this.context.qpLoading.close();
                        return;
                    }
                    let storeProductTypeList = res.storeProductTypeList;
                    let currentProduct = res.currentProduct;
                    if (!angular.isUndefined(storeId)) {
                        this.selectedStoreAndType('storeProductType', storeId, undefined, propertyModelId, currentProduct, storeProductTypeList);
                    } else {
                        // 打开店铺列表选择模态框（未选定店铺）
                        this.selectedStoreAndType('storesAndType', storeId, undefined, propertyModelId, currentProduct, storeProductTypeList);
                    }
                }, error => {
                    this.context.qpLoading.close();
                    throw error;
                })
        }, error => {
            this.context.qpLoading.close();
            this.context.context.onRequestFail(error);
        })
    }
    /**
     * @description 添加店铺产品（已确定要添加产品的店铺）
     * @param propertyModelId(必填)
     * @param storeId(必填)
     * @param whitelabelProductId（必填）
     * @param rootPath（必填）
     * @param storeProductType(必填)
     * @param storeType(必填)
     */

    public openStoreProductSetUpModal(storeId: string, propertyModelId: number | undefined, whitelabelProductId: number, rootPath: string, storeProductType: 'SKU' | 'CONFIGURABLE' | 'DESIGN', storeType: string) {

        this.$uibModal.open(
            {
                templateUrl: "store-product-steup.template.html",
                windowClass: "add-product",
                backdropClass: "add-product-backdrop",
                controller: "storeProductSetupController",
                controllerAs: "vm",
                resolve: {
                    items: () => {
                        // 获取产品属性版本信息
                        const attributeVersion = this.$scope.attributeVersion;
                        // 获取产品publishProfileCodes（该信息不一定存在）
                        const publishProfileCodes = this.$scope.publishProfileCodes ? this.$scope.publishProfileCodes : undefined;
                        // 获取产品详情页面publishProfileIds(number转string)
                        let publishProfileIds: Array<string> = [];
                        this.$scope.publishProfileIds.forEach(publishProfileId => {
                            publishProfileIds.push(String(publishProfileId));
                        })
                        // 获取产品详情页面cmsConfigVersion
                        const cmsConfigVersion = angular.isUndefined(this.$scope.cmsConfigVersion) ? undefined : this.$scope.cmsConfigVersion;
                        let _p = new SetupInitParams("add");
                        _p.propertyModelId = propertyModelId;
                        _p.storeId = storeId;
                        _p.rootPath = rootPath;
                        _p.storeType = (storeType && storeType != "" ? storeType : this.context.storeType);
                        // 设置产品属性版本信息
                        _p.attributeVersion = Number(attributeVersion);
                        // 设置产品publishProfileCodes
                        _p.publishProfileCodes = publishProfileCodes;
                        // 设置产品详情页面publishProfileIds
                        _p.publishProfileIds = publishProfileIds;
                        // 设置产品详情页面cmsConfigVersion
                        _p.cmsConfigVersion = cmsConfigVersion;
                        // 当前传入的产品id
                        _p.whitelabelProductId = whitelabelProductId;
                        // 店铺产品类型
                        _p.storeProuductType = storeProductType;
                        //  默认展开步骤项
                        if (_p.storeProuductType == 'CONFIGURABLE') {
                            _p.defaultStepName = "mockup";
                        } else {
                            _p.defaultStepName = "product";
                        }
                        // 更新店铺产品之后，跳转个人中心（店铺产品列表）
                        _p.closeCallback = (storeId) => {
                            if (storeId) {
                                this.$window.location.href = rootPath + "dashboard/index.html#!/store/" + storeId + "/products";
                            } else {
                                throw new Error("Data missing, store product Settings page, to return store product Id.");
                            }
                        }
                        return _p;
                    }
                }
            }
        )
    }

    /**
     * @description 选择店铺And店铺产品类型（storeProductType | storesAndType | stores）
     * @param modalType（必填）storeProductType | storesAndType | stores
     * @param storeId(必填)
    * @param storeProductType(必填)SKU | CONFIGURABLE | DESIGN
    * @param currentProduct(必填)ICurrentProduct
    * @param storeProductTypeList(非必填)
    */
    public selectedStoreAndType(modalType: string, storeId: string | undefined, storeProductType: string | undefined, propertyModelId: number | undefined, currentProduct: ICurrentProduct, storeProductTypeList: Array<IStoreProductType>) {
        const rootPath: string = this.context.pageContext.rootPath;
        // 开启选择店铺和店铺产品类型模态框
        let selectedStoreAndType = this.$uibModal.open(
            {
                templateUrl: "stores-and-type.template.html",
                windowClass: "store-product-type",
                backdropClass: "store-product-type-backdrop",
                controller: "storesAndTypeController",
                controllerAs: "$ctrl",
                backdrop: false,
                resolve: {
                    items: function () {
                        return {
                            rootPath: rootPath,
                            storeId: storeId,
                            modalType: modalType,
                            storeProductType: storeProductType,
                            storeProductTypeList: storeProductTypeList
                        }
                    }
                }
            }
        )
        // 关闭模态框，并开启店铺产品设置页
        selectedStoreAndType.result.then(item => {
            if (angular.isUndefined(item)) {
                return;
            }
            this.context.qpLoading.open();
            let storeAndTypeResult: IStoreAndTypeResult = item;
            let storeId: string, storeProductType: 'SKU' | 'CONFIGURABLE' | 'DESIGN';
            // 获取选中店铺数据 
            if (storeAndTypeResult.selectedStoreId) {
                storeId = storeAndTypeResult.selectedStoreId;
            } else {
                // 弹框提示，选中店铺数据缺失
                window.qpAlertPrompt.error("Tip", "The selected item store data is missing.")
                this.context.qpLoading.close();
                return;
            }
            // 获取店铺产品类型
            if (storeAndTypeResult.storeProductType) {
                storeProductType = item.storeProductType;
            } else {
                //弹框提示，店铺产品类型数据缺失
                window.qpAlertPrompt.error("Tip", "Product store type data is missing.")
                this.context.qpLoading.close();
                return;
            }
            //获取当前店铺产品类型，对应的whitelabelProductId，并开启店铺产品设置页；
            this.getWhitelabelProductId(storeProductType, currentProduct, propertyModelId)
                .then(res => {
                    const whitelabelProductId = res.data.whitelabelProductId;
                    // addProductToStore  
                    this.openStoreProductSetUpModal(storeId, propertyModelId, whitelabelProductId, this.context.pageContext.rootPath, storeProductType, storeAndTypeResult.storeType)
                }, error => {
                    this.context.onRequestFail(error);
                }).finally(() => {
                    this.context.qpLoading.close();
                })
        })
    }

    /**
     * @description 获取whitelabelProductId，根据制定店铺产品类型获取对应whitelabelProductId（SKU店铺产品 <--> sku产品Id | CONFIGURABLE店铺产品 <--> 可配置产品Id | DESIGN店铺产品  <-->  sku产品Id）    
    * @param storeProductType(必填)SKU | CONFIGURABLE | DESIGN
    * @param currentProduct(必填)产品详情页产品Id（sku产品/configurable产品）
    * @param propertyModelId 
    */
    public getWhitelabelProductId(storeProductType: string, currentProduct: ICurrentProduct, propertyModelId): angular.IPromise<IWhitelabelProductIdResult> {
        let defer = this.$q.defer<IWhitelabelProductIdResult>();
        // 根据店铺产品类型，生成对应的whitelabelProductId
        // 店铺产品类型为“SKU”/店铺产品类型为“DESIGN”，对应whitelabelProductId为sku产品
        if (storeProductType == "SKU" || storeProductType == "DESIGN") {
            // TODO 创建propertyModel
            if (angular.isUndefined(currentProduct.configurableProductId)) {
                defer.resolve({ success: true, data: { whitelabelProductId: currentProduct.skuProductId } });
            } else if (!angular.isUndefined(propertyModelId)) {
                // 创建sku产品（propertyModelId+configurableProductId）
                this.productV2RestService.creatSku(currentProduct.configurableProductId as number, Number(propertyModelId)).then(resp => {
                    let skuProductId = resp.data.id;
                    defer.resolve({ success: true, data: { whitelabelProductId: skuProductId } });
                }, error => {
                    defer.reject(error);
                })
            } else {
                defer.resolve({ success: true, data: { whitelabelProductId: currentProduct.skuProductId } });
            }
        }
        // 店铺产品类型为storeProductType == "CONFIGURABLE"，对应whitelabelProductId为configurable产品
        else if (storeProductType == "CONFIGURABLE") {
            defer.resolve({ success: true, data: { whitelabelProductId: currentProduct.configurableProductId } });
        } else {
            window.qpAlertPrompt.info("Tip", "The product type of this store is not supported for now.");
            defer.reject();
        }
        return defer.promise;
    }


    /**
     * @description判断当前产品详情类型（sku产品/configurable产品),并创建店铺产品类型数据（允许添加的店铺产品类型）
     * @param currentProductId
     * @return {currentProductType,storeProductTypeList}
     * */
    public getStoreProductTypeList(currentProductId: number): angular.IPromise<StoreProductTypeListResult> {
        this.qpLoading.open();
        let defer = this.$q.defer<StoreProductTypeListResult>();
        //currentProductObj 当前产品信息（产品类型，sku产品Id，configurable产品Id）
        let currentProductObj: ICurrentProduct, configurableProductId: number, currentProductType: string, skuProductId: number, storeProductTypeList: Array<IStoreProductType> = [];

        let productPromise;
        // 检查产品详情页中是否存在属性版本
        if (this.context.$scope.attributeVersion && !angular.isUndefined(this.context.$scope.attributeVersion)) {
            productPromise = this.productV2RestService.getOne(currentProductId, this.context.$scope.attributeVersion);
        } else {
            productPromise = this.productV2RestService.getOne(currentProductId)
        }
        // 确认当前产品类型，存储当前产品信息（产品类型，sku产品Id，configurable产品Id）            
        productPromise.then(productResp => {
            // 当前产品类型为sku产品，currentProductType赋值为'sku',创建创建店铺产品类型数据（[skuStoreproductObj]）
            if (productResp.data.multilingualKey == "com.qpp.cgp.domain.product.SkuProduct") {
                currentProductType = 'sku';
                if (productResp.data.configurableProductId) {
                    skuProductId = productResp.data.id;
                    configurableProductId = productResp.data.configurableProductId;
                } else {
                    skuProductId = productResp.data.id;
                }
                let skuStoreproductObj = new SkuStoreProductType();
                storeProductTypeList.push(skuStoreproductObj);
            }
            // 当前产品类型为configurable产品，currentProductType赋值为'configurable',创建创建店铺产品类型数据（[skuStoreproductObj,configurableStoreproductObj]）
            else if (productResp.data.multilingualKey == "com.qpp.cgp.domain.product.ConfigurableProduct") {
                currentProductType = 'configurable';
                configurableProductId = productResp.data.id;
                let skuStoreproductObj = new SkuStoreProductType();
                let configurableStoreproductObj = new ConfigurableStoreProductType();
                storeProductTypeList.push(skuStoreproductObj);
                storeProductTypeList.push(configurableStoreproductObj);
            } else {
                this.context.qpLoading.close();
                // 当前产品类型暂不支持，添加产品店铺（店铺产品类型选择）
                window.qpAlertPrompt.info('Tip', 'The current product cannot be added to the store');
                defer.reject();
            }
            //返回当前产品类型和添加店铺产品类型配置数据
            currentProductObj = {
                productType: currentProductType,
                skuProductId: skuProductId,
                configurableProductId: configurableProductId
            }
            // 檢查當前產品能否進行Builder定制；未添加builder地址配置，不允许添加“带设计的店铺产品”
            // 獲取Builder地址請求參數
            let builderPathParams = new BuilderUrlRequestParameter();
            builderPathParams.productId = currentProductId;
            builderPathParams.type = 'builder';

            let _builderParams: IPathParams = BuilderManager.creatParams(builderPathParams);
            _builderParams.builderType = "Designer";

            return this.builderRestService.getPath(_builderParams.builderType, _builderParams);
        }, error => {
            this.context.qpLoading.close();
            this.context.onRequestFail(error);
        }).then(builderPsathResp => {
            // builder地址配置，需大于V4版本，才可添加带设计的店铺产品
            if (!angular.isUndefined(builderPsathResp) && builderPsathResp) {
                let builderPath = builderPsathResp.data as string;
                const splitStart = builderPath.indexOf('/pc/') + 4;
                const splitEnd = builderPath.indexOf('/index.html')
                const builderVersion = builderPath.substring(splitStart, splitEnd);
                if (Number(builderVersion) >= 4) {
                    //检查当前产品是否存在builder配置，添加“带设计的店铺产品类型”配置[designStoreProductObj]
                    let designType = new DesignStoreProductType();
                    // 从店铺产品类型数组前面添加designType配置，使designType配置始终保持在第一个
                    storeProductTypeList.unshift(designType);
                }
            }
            // 返回已生成的StoreProductTypeList数据
            let storeProductTypeListResult = new StoreProductTypeListResult(currentProductObj, storeProductTypeList);
            storeProductTypeListResult['success'] = true;
            this.context.qpLoading.close();
            defer.resolve(storeProductTypeListResult);

        }, error => {
            // builder获取失败处理，不添加“带设计的店铺产品类型”配置[designStoreProductObj]
            // if (error.data.data.code == "200091" || "") {
            // 返回已生成的StoreProductTypeList数据
            let storeProductTypeListResult = new StoreProductTypeListResult(currentProductObj, storeProductTypeList);
            storeProductTypeListResult['success'] = true;
            this.context.qpLoading.close();
            defer.resolve(storeProductTypeListResult);
            // }
            // defer.reject();
        })
        return defer.promise;
    }


    /************************************ ADD STORE PRODUCT CHORE ************************************** */


   

}
